import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "webinar_card_icon_chat_send",
  "use": "webinar_card_icon_chat_send-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"webinar_card_icon_chat_send\"><path d=\"M10.656 14.358V7.19l3.215 3.132c.258.25.68.25.936 0a.627.627 0 0 0 0-.905l-4.342-4.23a.669.669 0 0 0-.93 0l-4.342 4.23a.627.627 0 0 0 0 .905c.257.25.672.25.929 0L9.338 7.19v7.168c0 .353.296.642.659.642a.652.652 0 0 0 .659-.642Z\" fill=\"#fff\" stroke=\"#fff\" stroke-width=\".7\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol